/** Imagen de portada: prioriza coverImage del artículo, luego categoría. */
export function resolveArticleCover(article, categories) {
  if (article?.coverImage) {
    return {
      src: article.coverImage,
      alt: article.coverImageAlt ?? article.title,
    };
  }
  const category = categories?.[article?.category];
  return {
    src: category?.cardImage ?? category?.heroImage ?? "",
    alt: category?.title ?? article?.title ?? "Artículo",
  };
}
